<template>
  <div class="text-center centered">
    <!-- <div class="row">
      <div class="col-12 mb-4">
        <div class="progress-bar-wrapper bg-light">
          <div
            :style="{
              width: this.$store.getters.progressBarStatus.width + '%',
            }"
            class="progress-bar"
          >
            <p class="mb-0 text-light">
              <strong>
                {{ this.$store.getters.progressBarStatus.width + "%" }}
              </strong>
            </p>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="row">
      <div class="col-12">
        <strong>
          <p
            class="message mb-0"
            v-html="this.$store.getters.progressBarStatus.message"
          ></p>
        </strong>
      </div>
    </div> -->
  </div>
  <div class="text-center centered">
    <div class="mb-3">
      <div
        :style="{ '--j': 1 }"
        :class="{
          'text-dark': $store.getters.checkIsLight,
          'text-light': !$store.getters.checkIsLight,
        }"
        class="mx-1 spinner-grow one"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
      <div
        :style="{ '--j': 2 }"
        :class="{
          'text-dark': $store.getters.checkIsLight,
          'text-light': !$store.getters.checkIsLight,
        }"
        class="mx-1 spinner-grow two"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
      <div
        :style="{ '--j': 3 }"
        :class="{
          'text-dark': $store.getters.checkIsLight,
          'text-light': !$store.getters.checkIsLight,
        }"
        class="mx-1 spinner-grow three"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <strong>
          <p
            class="message mb-0"
            v-html="this.$store.getters.progressBarStatus.message"
          ></p>
        </strong>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.progressBar();
  },
  updated() {
    this.progressBar();
  },
  computed: {
    isLight() {
      return this.$store.getters.checkIsLight;
    },
    progressBarState() {
      return this.$store.getters.progressBarStatus;
    },
  },
  methods: {
    progressBar() {
      this.width = this.$store.getters.progressBarStatus.width;
      this.message = this.$store.getters.progressBarStatus.message;
    },
  },
};
</script>
<style scoped>
.centered {
  margin: 25vh 0 auto 0;
}

/* Spinner Section */
.spinner-grow {
  width: 1rem !important;
  height: 1rem !important;
}

.spinner-grow.one {
  animation: 0.75s linear infinite spinner-grow;
  animation-delay: 0s;
}

.spinner-grow.two {
  animation: 0.75s linear infinite spinner-grow;
  animation-delay: 0.15s;
}

.spinner-grow.three {
  animation: 0.75s linear infinite spinner-grow;
  animation-delay: 0.3s;
}

/* Progress Bar Section */
.progress-bar-wrapper {
  width: 100%;
  border-radius: 10px;
  height: 20px;
  overflow: hidden;
  box-shadow: 0px 2px 10px 0px rgb(255 255 255 / 75%);
  transition: all 0.1s ease-in-out;
}

.light .progress-bar-wrapper {
  width: 100%;
  border-radius: 10px;
  height: 20px;
  overflow: hidden;
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 45%);
}

.progress-bar {
  width: 0;
  padding: 2px 0 0 0;
  border-radius: 0;
  height: 20px;
  text-align: center;
  font-size: 15px;
  background-color: #003479;
}

.message {
  font-size: 20px;
  color: #e0e0e0;
}

.light .message {
  color: #333;
}

@media only screen and (max-width: 400px) {
  .message {
    font-size: 18px;
  }
}
</style>
